import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components'
import {mapObjIndexed, assocPath, not, compose, values, any, pick, path} from 'ramda'
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonDefault, ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import {Error} from 'components/errors';
import Input from 'form/input'
import Spinner from 'spinner'
import {PageHead} from 'components/header/components';
import Box from 'components/box';
import Upload from 'components/upload'
import {Label, Divider, SelectWithSearchAsync, RequiredSpan} from 'components/common'

import {submitDoctor, doctorCleanStore, loadProfessions, loadDoctorDetail} from 'redux/actions/admin/doctors'

import close from 'images/general/close.svg';

const mapStateToProps = (state) => ({
  detail: state.doctors.get('doctorDetail'),
  doctorDetailsLoading: state.doctors.get('doctorDetailIsLoading'),
  doctorCreateFailed: state.doctors.get('doctorCreateFailed'),

  professions: state.doctors.get('professionsList'),
  professionsAreLoading: state.doctors.get('professionsAreLoading'),
  isSubmitting: state.doctors.get('doctorIsSubmitting'),
  hasError: state.doctors.get('doctorCreateFailed') || state.doctors.get('doctorUpdateFailed'),
  user: state.auth.get('user')
})

const mapDispatchToProps = dispatch => ({
  loadDoctorDetail: id => dispatch(loadDoctorDetail(id)),
  loadProfessions: search => dispatch(loadProfessions(search)),
  onSubmit: (userData, id = null) => dispatch(submitDoctor('/admin/doctors/detail/', userData, id)),
  onClean: () => dispatch(doctorCleanStore())
})

const UploadWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

class CreateDoctor extends Component {
  state = {
    userData: {
      profession: '',
      first_name: '',
      last_name: '',
      middle_name: '',
      email: '',
      photo: null,
    },
    errors: {
      profession: false,
      first_name: false,
      last_name: false,
      middle_name: false,
      email: false,
      photo: false,
    },
    formValid: true,
    professionSelect: '',
    editedSelect: false
  }

  selectWithSearchStyle = () => ({
    border: path(['errors', 'profession'], this.state) ? "solid 1px #7f1414" : "none"
  })

  renderValue = key => {
    return this.state.userData[key]
  }

  getError = key => path(['errors', key], this.state)

  renderFields = () => {
    const inputs = [
      {
        label: "Ім'я:",
        type: "text",
        placeholder: "Введіть ім'я",
        key: 'first_name',
        required: true
      },
      {
        label: "Прізвище:",
        type: "text",
        placeholder: "Введіть прізвище",
        key: 'last_name',
        required: true
      },
      {
        label: "По батькові:",
        type: "text",
        placeholder: "Введіть ім'я по батькові",
        key: 'middle_name',
        required: true
      },
      {
        label: "Пошта:",
        type: "text",
        placeholder: "Введіть email",
        key: 'email',
        required: true
      }]
    return inputs.map(field => {
      return <Input
        key={field.key}
        label={field.label}
        type={field.type}
        required={field.required}
        placeholder={field.placeholder}
        value={this.renderValue(field.key)}
        hasError={this.getError(field.key)}
        onChange={(event) => this.onValueChange(event.target.value, field.key)}
      />
    })
  }

  openModal = () => {
    const isFalse = value => Boolean(value)
    if(any(isFalse, values(this.state.userData))){
      this.toggleModal()
      return
    }
    this.props.history.goBack()
  }

  toggleModal = () => this.setState(prevState => ({modalOpen: !prevState.modalOpen}))

  onModalOk = () => {
    this.toggleModal()
    this.props.history.goBack()
  }

  onValueChange(value, key) {
    let createNewState = compose(assocPath(['userData', key], value), assocPath(['errors', key], false))
    this.setState(prevState => createNewState(prevState))
  }

  generateProfessionOptions = results => {
    return results.reduce((arr, item) => {
      const newOption = {value: item.get('id'), label: item.get('profession_title')}
      arr.push(newOption)
      return arr
    }, [])
  }

  loadProfessions = (search = '') => {
    return this.props.loadProfessions(search)
      .then(response => {
        const results = response.get('results')
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generateProfessionOptions(results)
        return { options }
      })
  }

  onChangeProfession = profession => {
    if(!profession) profession =  { value: '' }
    this.onValueChange(profession.value, 'profession')
    this.setState(() => ({professionSelect: profession, editedSelect: true}))
  }

  onChangeFile = file => this.onValueChange(file, 'photo')

  onSubmit = async event => {
    event.preventDefault()
    let requiredFields = ['profession', 'first_name', 'last_name', 'middle_name', 'email']
    await this.validateForm(requiredFields)
    if(not(this.state.formValid)) return
    this.props.onSubmit(this.state.userData, this.props.match.params.doctor_id)
  }

  generateError = (error) => { //TODO: make file with all errors and map on file
    if(!error) return
    let msg = ''
    if(error.email && error.email[0] === "Enter a valid email address."){
      msg = 'Ви ввели невірний email.'
    } else if(error.non_field_errors && error.non_field_errors[0] === "A user with that email already exists.") {
      msg = 'Обліковий запис з такою поштою вже існує. Будь ласка, введіть іншу пошту.'
    } else {
      msg = 'При збереженні даних виникла проблема. Перевірте, будь ласка, всі поля.'
    }
    return (
      <Error>
        {msg}
      </Error>
    )
  }

  validateForm(requiredFields = null) {
    let fields = requiredFields ? pick(requiredFields, this.state.userData) : this.state.userData
    let errors = {}
    mapObjIndexed((value, key) => {
      let valueError = !value
      errors = assocPath([key], valueError, errors)
    },  fields)
    let isInvalid = value => value
    if(any(isInvalid, values(errors))) {
      this.setState(() => ({ errors, formValid: false }))
    } else {
      this.setState(() => ({ errors, formValid: true }))
    }
  }

  renderBreadcrumbs = () => {
    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    if(isAdminInstitution) {
      return <Breadcrumbs>
        <li><Link to="/admin/doctors">Облікові записи</Link></li>
        {this.props.match.params.doctor_id ? (
            <li><p>Редагування облікового запису</p></li>
          ):(
            null
        )}
      </Breadcrumbs>
    }

    return (
      <Breadcrumbs>
        <li><Link to="/admin/">Головна</Link></li>
        <li><Link to="/admin/doctors/">Облікові записи</Link></li>
        {this.props.match.params.doctor_id ? (
            <li><p>Редагування облікового запису</p></li>
          ):(
            null
        )}
      </Breadcrumbs>
    )
  }

  componentDidMount() {
    const doctorId = this.props.match.params.doctor_id
    const detail = this.props.detail
    if(!doctorId) this.props.onClean()
    if(doctorId && !detail.size) this.props.loadDoctorDetail(doctorId)
    if(doctorId && detail.size) {
      this.setState(() => ({
        userData: {
          profession: detail.getIn(['profession_classification_data', 'id']),
          first_name: detail.getIn(['user_data', 'first_name']),
          last_name: detail.getIn(['user_data', 'last_name']),
          middle_name: detail.getIn(['user_data', 'middle_name']),
          email: detail.getIn(['user_data', 'email']),
          photo: detail.getIn(['user_data', 'photo']),
        },
        professionSelect: { value: detail.getIn(['profession_classification_data', 'id']), label: detail.getIn(['profession_classification_data', 'profession_title']) }
      }))
    }
  }

  componentWillReceiveProps (nextProps) {
    if(this.props.match.params.doctor_id) {
      this.setState(prevState => ({
        userData: {
          profession: nextProps.detail.getIn(['profession_classification_data', 'id']),
          first_name: nextProps.detail.getIn(['user_data', 'first_name']),
          last_name: nextProps.detail.getIn(['user_data', 'last_name']),
          middle_name: nextProps.detail.getIn(['user_data', 'middle_name']),
          email: nextProps.detail.getIn(['user_data', 'email']),
          photo: nextProps.detail.getIn(['user_data', 'photo']),
        }
      }))
    }

    const firstProps = nextProps.detail && not(this.state.userData.profession) && nextProps.match.params.doctor_id && not(this.state.editedSelect)
    if (firstProps) { //that means 'edit' mode and props must be spread to state
      this.setState(() => ({
        professionSelect: {
          value: nextProps.detail.getIn(['profession_classification_data', 'id']),
          label: `${nextProps.detail.getIn(['profession_classification_data', 'profession_title'])}`
        }
      }))
    }
  }

  componentWillUnmount() {
    this.props.onClean()
  }

  render() {
    if (this.props.match.params.doctor_id && this.props.doctorDetailsLoading)return <Spinner/>

    return (
      <div>
        {this.renderBreadcrumbs()}
        <PageHead>
          <h2>{this.props.match.params.doctor_id ? "Редагувати обліковий запис" : "Додати обліковий запис"}</h2>
        </PageHead>

        <Box title4={this.props.match.params.doctor_id ? "Форма редагування облікового запису" : "Форма додавання облікового запису"}>
          <form onSubmit={this.onSubmit}>
          
            {this.renderFields()}

            <Divider>
              <Label>Спеціальність: <RequiredSpan hasError={this.getError('profession')}>*</RequiredSpan></Label>
              <SelectWithSearchAsync
                searchable={true}
                isSearchable={true}
                hasError={this.getError('profession')}
                value={this.state.professionSelect}
                loadOptions={this.loadProfessions}
                valueKey={'value'}
                labelkey={'label'}
                required
                onChange={this.onChangeProfession}
                style={ this.selectWithSearchStyle() }
                placeholder="Починайте вводити для пошуку..."
                noResultsText="Немає результатів"
              />
            </Divider>


            <UploadWrapper>
              <Upload
                loadImage
                label="Дoдати фото"
                accept=".png, .jpg, .jpeg, .gif"
                onChange={this.onChangeFile}
                file={this.renderValue('photo')}
                error={this.state.errors.photo}
              />
            </UploadWrapper>

            <Divider/>
            <ButtonDefault disabled = {this.props.isSubmitting} type="submit" value="Зберегти"/>

            <ButtonDefault onClick={this.openModal} value="Вийти без збереження"/>
          </form>

          {this.generateError(this.props.doctorCreateFailed)}

        </Box>

        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                    className={{
                      base: 'modalContent',
                      afterOpen: 'myClass_after-open',
                      beforeClose: 'myClass_before-close'
                    }} contentLabel="Підтвердження запису"
                    overlayClassName={{
                      base: 'modalOverlay',
                      afterOpen: 'myOverlayClass_after-open',
                      beforeClose: 'myOverlayClass_before-close'
                    }}>
          <div>
            <Modal>
              <CloseModal>
                <div>
                  <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
              </CloseModal>

              <ModalContent>
                <h3>
                  Ви впевнені, що хочете вийти без збереження?
                  Всі внесені зміни будуть скасовані
                </h3>
                <ButtonWrap>
                  <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>

            </Modal>
          </div>
        </ReactModal>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateDoctor);



// WEBPACK FOOTER //
// ./src/admin/doctors/create.js